import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function ShippersAPI(): BringozApi {
  return {
    base: `/shippers`,
    infiniteScroll: {
      address: `/shippers`,
      cmd: 'GET'
    },
    actions: {
      updatePassword: {
        address: '{id}/password',
        cmd: 'POST',
        updateable: false
      },
      deleteShipper: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: false
      },
      addShipperApi: {
        address: 'api',
        cmd: 'PUT',
        updateable: true
      }
    }
  }

}

angular
  .module('bringoz.admin.shippers')
  .factory('ShippersAPI', ShippersAPI);
